"use client";
import React, { useRef, useEffect } from "react";
import { createRipple } from "./HeroSection";

const CtaSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    el.classList.add("reveal-hidden");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.remove("reveal-hidden");
          el.classList.add("section-reveal");
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="cta"
      ref={sectionRef}
      className="relative py-20 md:py-28 px-6"
    >
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center gap-6">
        <div className="ornament">
          <span className="text-accent text-xl">✦</span>
        </div>

        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-foreground">
          Your transformation <br />
          <span className="shimmer-gold italic">begins within.</span>
        </h2>

        <p className="text-foreground-muted text-base md:text-lg font-body max-w-lg">
          Take the first step toward clarity, healing, and a transformed life.
        </p>

        <a
          href="https://wa.me/919993297909?text=Hi%2C%20I%20want%20to%20book%20a%20tarot%20reading%20session."
          target="_blank"
          rel="noopener noreferrer"
          className="btn-gold px-10 py-4 rounded-full text-base mt-4"
          onMouseDown={createRipple}
        >
          Book Your Session
        </a>
      </div>
    </section>
  );
};

export default CtaSection;
